import { Button } from "@mui/material"
import { downloadTasksAsExcelSpreadsheet } from "routes/regime/plugins/download-tasks/controller/download-tasks-as-excel-spreadsheet"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useState } from "react"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import Iconify from "minimals-template/components/Iconify"
import { ProvideExcelData } from "event-definitions"
import { waitForShareLinkDownload } from "routes/regime/plugins/share-link-download-progress/wait-for-share-link-download"

const DOWNLOAD_EXCEL_SNACKBAR_KEY = "download-excel"

export function DownloadTasksAsExcelSpreadsheet() {
    const [downloading, setDownloading] = useState(false)
    const { shareLink } = useBoundContext()

    return (
        !!shareLink.canDownloadExcel && (
            <Button
                fullWidth
                data-cy="download-excel-button"
                disabled={downloading}
                size="small"
                endIcon={downloading && <Iconify icon="ic:round-hourglass-empty" className="iconSpin" />}
                startIcon={<Iconify icon="mdi:download" />}
                sx={{ alignSelf: "center" }}
                onClick={download}
            >
                Download Tasks (Excel)
            </Button>
        )
    )

    async function download() {
        try {
            setDownloading(true)
            const result = await downloadTasksAsExcelSpreadsheet(shareLink._id)
            const excelData = await waitForShareLinkDownload({
                result,
                message: "Downloading Excel. For large regimes this may take a while. Please remain on the share link.",
                snackbarKey: DOWNLOAD_EXCEL_SNACKBAR_KEY,
                dataEvent: ProvideExcelData,
            })
            if (excelData) {
                const a = document.createElement("a")
                a.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${excelData}`
                a.download = `${shareLink.name}-tasks.xlsx`
                a.click()
                successSnackbar(`${shareLink.name}-tasks.xlsx created`)
            } else {
                errorSnackbar("Could not find the tasks to download")
            }
        } catch (e) {
            errorSnackbar(typeof e === "string" && e ? e : "Failed to download tasks.")
            console.error("Failed to download", e)
        } finally {
            setDownloading(false)
        }
    }
}
